(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > 50) {
        this.header.classList.add('scrolled-past-header');
      } else {
        this.header.classList.remove('scrolled-past-header');
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-hints-bubble"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.getElementById('rf-sticky-hint-{{ section.id }}');
    if (!root) return;

    const behavior = root.dataset.behavior || 'always';
    const dismissKey = root.dataset.dismissKey;
    const closeBtn = root.querySelector('.rf-sticky-hint__close');
    const textNode = root.querySelector('.rf-sticky-hint__link');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const configuredBadgeSize = Number('{{ section.settings.badge_size_desktop }}') || 140;

    const hide = () => root.classList.add('is-hidden');
    const show = () => root.classList.remove('is-hidden');

    if (prefersReducedMotion) {
      root.style.transition = 'none';
    }

    if (dismissKey && localStorage.getItem(dismissKey) === '1') {
      hide();
    }

    const applyBadgeSizing = () => {
      if (!root.classList.contains('rf-sticky-hint--badge') || !textNode) return;
      if (window.matchMedia('(max-width: 749px)').matches) return;

      const textLength = textNode.textContent.trim().length;
      const computedSize = Math.max(configuredBadgeSize, Math.min(220, 82 + textLength * 3.6));
      const computedFont = Math.max(12, Math.min(17, 16 - textLength * 0.15));

      root.style.setProperty('--rf-badge-size', `${computedSize}px`);
      root.style.setProperty('--rf-badge-font-size', `${computedFont}px`);
    };

    applyBadgeSizing();
    window.addEventListener('resize', applyBadgeSizing);

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        hide();
        if (dismissKey) localStorage.setItem(dismissKey, '1');
      });
    }

    if (behavior === 'hide_after_header') {
      const header = document.querySelector('.section-header');
      if (!header) return;

      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry) return;
          if (entry.isIntersecting) {
            show();
          } else {
            hide();
          }
        },
        {
          root: null,
          threshold: 0.01
        }
      );

      observer.observe(header);
    } else if (behavior === 'always') {
      show();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
